import imgImage23 from "../../../assets/8df35d1a0f79dd36636505a05e8c29182bfeac21.png";
import imgImage24 from "../../../assets/22aa86772aca943ffeb9150d2b2dac327112b986.avif";

const Header = () => {
  return (
    <div className="border-b border-gray-200 h-[60px] md:h-[80px]">
      <div className="container mx-auto px-4 h-full flex items-center justify-between max-w-[1560px]">
        <div className="h-[35px] w-[100px] md:h-[50px] md:w-[140px]">
          <img
            src={imgImage23}
            alt="PCComponentes"
            className="w-full h-full object-contain"
          />
        </div>
        <div className="flex items-center gap-1 md:gap-2">
          <p className="text-[#6a7282] text-[10px] md:text-[12px] leading-[16px]">
            Seguro proporcionado por
          </p>
          <div className="h-[32px] md:h-[45px]">
            <img
              src={imgImage24}
              alt="Línea Directa"
              className="h-full w-auto  object-contain"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
